import React, { useEffect, useState } from "react";
import "./Certifications.scss";
import ReactMarkdown from "react-markdown";
import { useTranslation } from "react-i18next";
import { Breadcrumbs, Layout } from "@netapp/bxp-design-system-react";
import { LangLink } from "../../utils/langNavigation";
import { getContentPath, loadMarkdownContent } from "../../utils/contentLoader";

const Certifications = () => {
  const { i18n, t } = useTranslation();
  const [certificationsData, setCertificationsData] = useState({
    frontMatter: {},
    content: "",
  });

  useEffect(() => {
    async function fetchCertifications() {
      try {
        const filePath = getContentPath("/content/certifications/_index", i18n.language);
        const { frontMatter, content } = await loadMarkdownContent(filePath);
        setCertificationsData({ frontMatter, content });
      } catch (error) {
        console.error("Error fetching certifications markdown:", error);
      }
    }
    fetchCertifications();
  }, [i18n.language]);

  const title = certificationsData.frontMatter?.longtitle || "Certifications";
  const slogan = certificationsData.frontMatter?.slogan || "";
  const description = certificationsData.frontMatter?.description || "";

  return (
    <div className="certificationsFrame">
      <Layout.Page>
        <Layout.Content className="content-padding">
          <Layout.BreadcrumbsContainer className="breadcrumb-container">
            <Breadcrumbs>
              <LangLink to="/" className="breadcrumb-link">
                {t("securityPortal.other")}
              </LangLink>
              <div>{title}</div>
            </Breadcrumbs>
          </Layout.BreadcrumbsContainer>

          <div className="first-frame-certifications">
            <div className="certifications-main-frame">
              <div className="title-and-slogan">
                <div className="title-certifications">{title}</div>
                {slogan && <div className="title-slogan">{slogan}</div>}
              </div>
              {description && (
                <div className="title-description">{description}</div>
              )}
            </div>
          </div>
        </Layout.Content>

        <div className="second-frame-certifications">
          <div className="inside-second-certifications">
            <div className="certifications-content">
              <ReactMarkdown>{certificationsData.content}</ReactMarkdown>
            </div>
          </div>
        </div>
      </Layout.Page>
    </div>
  );
};

export default Certifications;